import { render } from "./Otp.vue?vue&type=template&id=77c729ce&scoped=true"
import script from "./Otp.vue?vue&type=script&lang=js"
export * from "./Otp.vue?vue&type=script&lang=js"

import "./Otp.vue?vue&type=style&index=0&id=77c729ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c729ce"]])

export default __exports__